import "keen-slider/keen-slider.min.css";
import KeenSlider from "keen-slider";

/**

Create a Campaign Family Slider found in the influencer view of the PDP.
  ---  content of family slider set in pdp customizer
  ---  only displays on campaign view ( snippets/campaign-widget )
  ---  content displays on bottom half of page, is shared for every influencer
  --- uses <campaign-family-slider> and <campaign-family-nav> custom elements

  todo: rework global slider to work with campaign family slider design

 @property {Object} slider - Slider object.
 @property {HTMLElement} slider.container - Slider container element.
 @property {Object} slider.instance - KeenSlider instance of the slider.
 @property {HTMLElement[]} slider.slides - Array of slider slide elements.
 @property {Object} nav - Navigation object.
 @property {HTMLElement} nav.container - Navigation container element.
 @property {HTMLElement[]} nav.links - Array of navigation links.
 @property {number} index - Current index of the displayed slide.
*/

export class CampaignFamilySlider {
  constructor() {
    this.slider = {
      container: document.querySelector("campaign-family-slider"),
      instance: false,
      slides: false,
    };
    this.nav = {
      container: document.querySelector("campaign-family-nav"),
      links: false,
    };
    this.index = 0;
  }

  // build slider
  _build = () => {
    this.slider.instance = new KeenSlider(this.slider.container, {
      selector: this.slides,
      loop: true,
      defaultAnimation: {
        duration: 3000,
      },
      created: (el) => {
        el.moveToIdx(this.index, true, { duration: 0 });
        this._addControls();
      },
      slideChanged: (data) => {
        this.slides[this.index].setAttribute("aria-hidden", true);
        this.slides[data.track.details.rel].setAttribute("aria-hidden", false);
        this._updatNav(data.track.details.rel);
      },
      detailsChanged: (s) => {
        s.slides.forEach((element, idx) => {
          element.style.opacity = s.track.details.slides[idx].portion;
        });
      },
      renderMode: "custom",
    });
  };

  /**

    Update the navigation links to indicate the current slide.
    @param {number} idx - The index of the current slide.
  */
  _updatNav = (idx) => {
    const oldLink = this.nav.links[this.index];
    const newLink = this.nav.links[idx];

    oldLink.style.fontWeight = "normal";
    oldLink.setAttribute("aria-current", false);

    newLink.style.fontWeight = "bold";
    newLink.setAttribute("aria-current", true);
    this.index = idx;
  };

  /**
  Handle the click event on the navigation links.
  @param {Event} e - The click event.
  */
  _handleClick = (e) => {
    this.slider.instance.moveToIdx(
      parseInt(e.currentTarget.dataset.key),
      true,
      { duration: 0 }
    );
  };

  /**
    Add event listeners to the navigation links.
  */
  _addControls = () => {
    this.nav.links = this.nav.container.querySelectorAll("button");
    this.nav.links.forEach((el) => {
      el.addEventListener("click", this._handleClick);
    });
  };

  /**
   Update the slider and navigation elements.
  */
  _update = () => {
    this.slider.container = document.querySelector("campaign-family-slider");
    this.nav.container = document.querySelector("campaign-family-nav");
    this.slides = this.slider.container.childNodes;
  };

  /**
    Set up the event listener to reload the slider.
  */
  _setReload = () => {
    window.addEventListener("recharge:reload", () => {
      this.slider.instance.update();
      this._update();
      this._build();
    });
  };

  // initialize slider if container and slides exsist
  _init = () => {
    this.slides = this.slider.container
      ? this.slider.container.childNodes
      : false;
    if (this.slides) {
      this._build();
      this._setReload();
    }
  };
}
